module.exports = __webpack_public_path__ + "static/media/IconoResultadosAprendizaje.993d56ff.svg";